import * as React from 'react';
import { useSelector } from 'react-redux';

import { useDeviceType } from '@cian/ui-kit/responsive';

import { BackToPageDesktop, BackToPageMobile } from '../../components/BackToPage';
import { TBackBtnTexts } from './utils/getButtonTextByReferrer';
import { withApplicationContext, TMapContextToProps } from '../../utils/withApplicationContext';
import { useFormTracking } from '../../utils/useFormTracking';
import { IBackToPageContainerContextProps } from './types';
import { useButtonProps } from './utils/useButtonProps';
import { selectIsWebview } from '../../selectors/selectIsWebview';

export function _BackToPageContainer(props: IBackToPageContainerContextProps) {
  const deviceType = useDeviceType();
  const { trackBackToPage } = useFormTracking();
  const { href, text } = useButtonProps(props);
  const isWebview = useSelector(selectIsWebview);

  /**
   * Для вебвью никогда не показывает кнопку назад/крестик закрытия
   */
  if (!href || !text || isWebview) {
    return null;
  }

  const BackToPage = deviceType === 'desktop' ? BackToPageDesktop : BackToPageMobile;

  return <BackToPage text={text} href={href} onClick={trackBackToPage} />;
}

const mapContextToProps: TMapContextToProps<IBackToPageContainerContextProps> = ({ config }) => {
  return { backBtnTexts: config.get<TBackBtnTexts>('requestFormRealtor.backBtnTexts') || [] };
};

export const BackToPageContainer = withApplicationContext(mapContextToProps)(_BackToPageContainer);
